import { getItemActionType, getTargetData } from '../cta/cta.utils';
import CTA from '../cta/cta.constants';
import {
  BOOKMARKS_PATH,
  HOME_PATH,
  FRONTSPACE_PATH,
  FOLDER_PATH,
  FOLDERS_PATH,
  INFORMATION_PATH,
  USAGE_TERMS_PATH,
  SUBSCRIPTION_TERMS_PATH,
  LEGAL_CONDITIONS_PATH,
  PROFILE_PATH,
  PROGRAM_PATH,
  SETTINGS_PATH,
  SERVICES_PATH,
  SERVICE_PATH,
  SEARCH_PATH,
  VIDEO_PATH,
  LIVES_PATH,
} from '../routes/routes.utils';

export const actionToPath = item => {
  const type = getItemActionType(item);
  const targetData = getTargetData(item);
  const { id } = targetData;

  switch (type) {
    case CTA.BOOKMARKS:
      return BOOKMARKS_PATH;
    case CTA.BOOKMARK:
      return '';
    case CTA.UNBOOKMARK:
      return '';
    case CTA.CLOSE:
      return HOME_PATH;
    case CTA.FOLDER:
      return `${FOLDER_PATH}/${id}`;
    case CTA.FOLDERS:
      return FOLDERS_PATH;
    case CTA.FRONTSPACE:
      return `${FRONTSPACE_PATH}/${id}`;
    case CTA.HOME_ALIAS:
      return HOME_PATH;
    case CTA.INFORMATION:
      return INFORMATION_PATH;
    case CTA.USAGE_TERMS:
      return USAGE_TERMS_PATH;
    case CTA.SUBSCRIPTION_TERMS:
      return SUBSCRIPTION_TERMS_PATH;
    case CTA.LEGAL_CONDITIONS:
      return LEGAL_CONDITIONS_PATH;
    case CTA.LIVE:
      return '';
    case CTA.LIVES:
      return LIVES_PATH;
    case CTA.LOCK:
      return '';
    case CTA.LOGOUT:
      return '';
    case CTA.OPTOUT:
      return SETTINGS_PATH;
    case CTA.PROFILE:
      return PROFILE_PATH;
    case CTA.PROGRAM:
      return `${PROGRAM_PATH}/${id}`;
    case CTA.SEARCH:
      return SEARCH_PATH;
    case CTA.SERVICE:
      return `${SERVICE_PATH}/${id}`;
    case CTA.SERVICES:
      return SERVICES_PATH;
    case CTA.VIDEO:
      return VIDEO_PATH;
    case CTA.HELP:
      return '';
    default:
      break;
  }

  return '';
};

export const isSameNavigationItem = (a, b) => {
  if (!a || !b || !a.entry || !b.entry) {
    return false;
  }

  if (a.entry.id !== b.entry.id) {
    return false;
  }

  if (a.entry.image) {
    if (!b.entry.image) {
      return false;
    }

    if (a.image.id !== b.image.id) {
      return false;
    }
  } else if (b.entry.image) {
    return false;
  }

  if (a.subentries) {
    if (!b.subentries) {
      return false;
    }

    if (a.subentries.length !== b.subentries.length) {
      return false;
    }

    for (let i = 0; i < a.subentries.length; i += 1) {
      if (a.subentries[i].id !== b.subentries[i].id) {
        return false;
      }
    }
  } else if (b.subentries) {
    return false;
  }

  return true;
};

export const isSameNavigation = (a, b) => {
  if (!a || !b || !a.entries || !b.entries) {
    return false;
  }

  if (a.entries.length !== b.entries.length) {
    return false;
  }

  for (let i = 0; i < a.entries.length; i += 1) {
    if (!isSameNavigationItem(a.entries[i], b.entries[i])) {
      return false;
    }
  }

  return true;
};
